
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Добавете го към началния си екран за по-добро преживяване и лесен достъп.`,
's224cbcec014ef6b5': `Натиснете „Сподели“ в лентата за навигация.`,
's37a9e8aec5713460': `Разшири`,
's386eca8362ff6155': `Натиснете „Още“, ако няма икона „Сподели“`,
's4e1e10a6ca408245': `Натиснете „Добави към началния екран“`,
's6196153c4b0c1ea0': `Инсталирайте`,
's633502f7cff4f847': `Отворете менюто на браузъра си`,
's681e399d63311fba': `Покажи галерия`,
's7f0591f08e318eda': `Натиснете „Още“ в менюто „Сподели“`,
's8114bd55cae5a22b': `Натиснете „Добави към Dock“`,
's922329d6f6213590': `Добави към Dock`,
's9af56bf005b49c74': `Превъртете надолу до „Добави към началния екран“`,
'sa5ef80b4bb9b39f8': `Свий`,
'sba52286c21552a4e': `Инсталирайте го на вашето устройство за по-пълноценно изживяване и по-лесен достъп.`,
'sc16e00a7a8b2fde2': `Назад`,
'scdaf4bbff76674c8': `Добави към началния екран`,
'se0e473adfda8066c': `Отворете в основния си браузър`,
'se740f75b95a51807': `Добавете го към Dock за по-пълноценно преживяване и по-лесен достъп.`,
'sfea652f6580ff086': `Този сайт работи като приложение.`,
    };
  